import React, { Component } from "react";
import Layout from "../../../Layout/layout";
import Helmet from "react-helmet";
import ReportButtonGroup from "../../commoncomponents/reportButtonGroup";
import "../../../styles/reports/reports.scss";
import "../../../styles/tools/colors.scss";
import { Button } from "react-bootstrap";
import Calendar from "react-calendar/dist/umd/Calendar";
import { apiHost } from "../../../api/apiClient";
import { setLoadingPage, setErrorMessage, setHeaderVisible } from "../../../reducers/actions";
import { connect } from "react-redux";
import axios from "axios";
import moment from "moment";
import "@emotion/core";
import GridLoader from "react-spinners/GridLoader";
import DropDownSearch from "../../commoncomponents/dropDownSearch";
import MultiDropDown from "../../commoncomponents/multiDropDown";
import TruckSelect from "./truckSelect";
import MultiVisitMap from "../../maps/multiVisitMap";
import $ from "jquery";

class Multiasset extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataPlaceholder: moment().subtract(1, 'days').format("dddd Do MMMM, YYYY"),
      date: moment().subtract(1, 'days').toDate(),
      calendarShow: false,
      checked: true,
      selectedDate: moment().subtract(1, 'days').format("YYYY-MM-DD"),
      reportLoader: false,
      generatedDate: moment().subtract(1, 'days').format("DD-MMM hh:mm a"),
      selectedGroupName: "Select Group",
      selectGroupId: "",
      groupData: [],
      assetData: [],
      selectAssetData: null,
      finalDataArr: [],
      depots: [],
      redraw: false,
      showContent: false,
    };
    this.finalDataArr = [];
    this.colourArr = ["#AF04D6", "#D84A08", "#138ED6", "#09994C", "#CC0066", "#66FFFF", "#00FF00", "#FF9900", "#FFFF00", "#999966"];
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.maxDate = moment().subtract(1, 'days').toDate();
  }

  componentDidMount() {
    this.setGroupList();
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  /**
   * Set the wrapper ref
   */
  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ calendarShow: false });
    }
  }

  calendarFunction = () => {
    this.setState({
      calendarShow: !this.state.calendarShow,
    });
  };

  onChangeDate = (date) => {
    this.setState({
      date: date,
      dataPlaceholder: moment(date).format("dddd Do MMMM, YYYY"),
      selectedDate: moment(date).format("YYYY-MM-DD"),
      calendarShow: false,
    });
  };

  handleCheckup = () => {
    this.setState({
      checked: !this.state.checked,
    });
  };

  handleWindow = () => {
    this.props.setHeaderVisibleAction(!this.props.headerHide);
  };

  handleCreateReport = async () => {
    this.setState({
      reportLoader: true,
      generatedDate: moment().format("DD-MMM hh:mm a"),
      finalDataArr: [],
      depots: [],
      redraw: true,
    });

    await this.getMultiAssetData();
  };

  handleFullScreen = () => {
    $("#mapContainerVisit")[0].requestFullscreen();
  };

  getMultiAssetData = async () => {
    try {
      let multiData = await axios.post(
        `${apiHost}/api/Report/map`,
        {
          AssetIds: this.getAssetIds(this.state.selectAssetData), //["08d7c00a-f58f-4d4a-8f29-1b35a4dd9518"], // //  //
          SearchDate: this.state.selectedDate, //"2020-04-01", // //
          Timezone: localStorage.getItem("timeZoneID"),
          UseFiltering: false,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      this.finalDataArr = [];
      this.setState({ reportLoader: false, showContent: true });
      multiData.data.forEach((single, index) => {
        this.createTotalMapData(single, index);
      });
      const depots = multiData.data
        .map((item) => {
          return item.depot;
        })
        .filter((value) => value != null);

      const distinctDepots = depots.filter((depot, index, self) => index === self.findIndex((d) => d.depotId === depot.depotId));
      this.setState({
        finalDataArr: this.finalDataArr,
        depots: distinctDepots,
      });
    } catch (e) {
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  colourReturn = (data) => {
    let colourSend = "";
    this.state.selectAssetData.forEach((element) => {
      if (element.id == data.assetId) {
        colourSend = element.colour;
      }
    });
    // console.log("element.colour", colourSend);
    return colourSend;
  };

  createTotalMapData = (data, index) => {
    let color = this.colourReturn(data);

    let finalobj = {
      id: data.assetId,
      colour: color,
      depotName: data.depotName,
    };
    let tripFinalArr = [];

    data.mapObjects.forEach((element) => {
      let singleTripArr = [];

      element.tripMapPoints.forEach((single) => {
        const singleObj = {
          lat: single.latitude,
          lng: single.longitude,
          angle: single.heading,
        };
        singleTripArr.push(singleObj);
      });
      tripFinalArr.push(singleTripArr);
    });
    finalobj.trips = tripFinalArr;

    let subTripArr = [];
    data.tripMapObjects.forEach((subTrip) => {
      const subTripObj = {
        lat: subTrip.lastMessage.gPRMC.latitude,
        lng: subTrip.lastMessage.gPRMC.longitude,
        assetName: subTrip.assetName,
        address: subTrip.address,
        arrived: subTrip.arrived,
        departed: subTrip.departed,
        parked: subTrip.parked,
        name: subTrip.positionName,
        tempA: subTrip.lastMessage.sensorAValue,
        tempB: subTrip.lastMessage.sensorBValue,
        fridge: subTrip.lastMessage.iO1 == 1 ? "On" : "Off",
      };
      subTripArr.push(subTripObj);
    });

    const firstPosition = {
      name: this.testNull(data.startPosition, "positionName"),
      recieved: this.testNull(data.startPosition, "recieved"),
      assetName: this.testNull(data.startPosition, "assetName"),
      address: this.testNull(data.startPosition, "address"),
      parked: this.testNull(data.startPosition, "parked"),
      speed: this.testNull(data.startPosition, "speed"),
      lat: this.testNull(data.startPosition, "latitude"),
      lng: this.testNull(data.startPosition, "longitude"),
    };
    const lastPosition = {
      lat: this.testNull(data.endPosition, "latitude"),
      lng: this.testNull(data.endPosition, "longitude"),
    };

    finalobj.subTrips = subTripArr;
    finalobj.first = firstPosition;
    finalobj.last = lastPosition;
    this.finalDataArr.push(finalobj);
  };

  testNull = (data, value) => {
    if (data && data[value]) {
      let thing = data[value];
      return thing;
    } else {
      return null;
    }
  };

  getAssetIds = (datas) => {
    let returnArr = [];
    datas.forEach((data) => {
      returnArr.push(data.id);
    });
    return returnArr;
  };

  handleGroupSelect = (value) => {
    // console.log("value", value);
    this.setState({
      selectedGroupName: `${value.groupName} - ${value.customername}`,
      selectGroupId: value.groupId,
      selectAssetData: [],
      assetData: [],
    });
    this.setSpecificGroup(value.groupId);
  };

  handleAssetSelect = (data) => {
    data.forEach((single, index) => {
      single.colour = this.colourArr[index];
    });
    this.setState({ selectAssetData: data });
  };

  setGroupList = async () => {
    try {
      const response = await axios.get(`${apiHost}/api/Assets/GroupsByCurrentUser`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      if (response.status == "200") {
        this.setState({ groupData: response.data });
      }
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      }
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  setSpecificGroup = async (id) => {
    try {
      const response = await axios.get(`${apiHost}/api/Assets/AssetsByCustomerIdWithIMEI?GroupId=${id}&IsReport=true`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      if (response.status == "200") {
        let assetData = [];
        response.data.forEach((element) => {
          const obj = {
            id: element.assetId,
            name: element.assetName,
          };
          assetData.push(obj);
        });
        this.setState({ assetData });
      }
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      }
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  handleTruckSelection = (click, id) => {
    this.setState((prevState) => {
      const finalDataArr = click
        ? [...prevState.finalDataArr, this.finalDataArr.find((item) => item.id === id)]
        : prevState.finalDataArr.filter((item) => item.id !== id);

      return {
        finalDataArr,
        redraw: false,
      };
    });
  };

  render() {
    const calendarReport = this.state.calendarShow ? (
      <div ref={this.setWrapperRef} className="ParentCalender" style={{ position: "relative", zIndex: 100 }}>
        <div className="CalendarContainer" style={{ position: "absolute" }}>
          <Calendar maxDate={this.maxDate} onChange={this.onChangeDate} value={this.state.date} />
        </div>
      </div>
    ) : (
      ""
    );

    let groupValues = [];
    this.state.groupData.forEach((element) => {
      groupValues.push(element.name);
    });

    return (
      <Layout>
        <Helmet>
          <title>Multi Asset Visit Report</title>
        </Helmet>
        <div className="contentBody">
          <div className={!this.props.headerHide ? `contentWrapper contentWrapperSmoothRelease` : `contentWrapper contentWrapperSmooth`}>
            <div className="headingContainer">
              <h2 className="mainHeading">
                Multi Asset Visit Report <span>v1.0.7.2</span>
              </h2>
              <i className={this.props.headerHide ? `fa fa-window-restore` : `fa fa-window-maximize`} onClick={this.handleWindow} />
            </div>
            <hr />
            <div className="inputFormGroup py-2">
              <div className="inputElementMulti">
                <DropDownSearch
                  caption={this.state.selectedGroupName}
                  icon="fa-truck"
                  values={this.state.groupData}
                  onParentCall={this.handleGroupSelect}
                />
              </div>
              <div className="inputElementMulti">
                <MultiDropDown assetData={this.state.assetData} onParentCall={this.handleAssetSelect} selectGroupId={this.state.selectGroupId} />
              </div>
              <div className="inputElementMulti">
                <ReportButtonGroup
                  function={this.calendarFunction}
                  dropDown={calendarReport}
                  placeholder={this.state.dataPlaceholder}
                  icon="fa-calendar"
                />
              </div>
              <div className="inputElementMulti">
                {this.state.selectGroupId != "" && this.state.selectAssetData != null ? (
                  <Button variant="outline-secondary" onClick={this.handleCreateReport} size="sm">
                    Create Report
                  </Button>
                ) : (
                  <Button variant="outline-secondary" onClick={this.handleCreateReport} size="sm" disabled>
                    Create Report
                  </Button>
                )}
              </div>
            </div>
            <div className="reportBody">
              {this.state.reportLoader ? (
                <div className="loaderLine">
                  <br />
                  <GridLoader size={7} color={"#222222"} loading={this.state.reportLoader} />
                  <h1> &nbsp;Generating Report</h1>
                  <br />
                </div>
              ) : (
                <React.Fragment>
                  <React.Fragment>
                    <div className="truckSelect-container">
                      {this.state.selectAssetData != null &&
                        this.state.selectAssetData.map((truck) => {
                          return (
                            <TruckSelect
                              key={truck.id}
                              name={truck.value}
                              colour={truck.colour}
                              id={truck.id}
                              onParentCall={this.handleTruckSelection}
                            />
                          );
                        })}
                    </div>
                    {this.state.showContent && (
                      <div className="containerMap">
                        <MultiVisitMap depots={this.state.depots} finalDataArr={this.state.finalDataArr} redraw={this.state.redraw} />
                        <div className="overlayFullScreen">
                          <Button className="transparent" onClick={this.handleFullScreen}>
                            <i className="fa fa-expand"></i>
                          </Button>
                        </div>
                      </div>
                    )}
                  </React.Fragment>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
  headerHide: state.headerHide,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
  setHeaderVisibleAction: setHeaderVisible,
};

export default connect(mapStateToProps, mapDispatchToProps)(Multiasset);
